import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const Tab = ({
  tabTitle,
  tabId,
  tabpanelId,
  isActive,
  isFocused,
  clickHandler,
  keyDownHandler,
}) => {
  const tabRef = useRef();

  // Set focus on the tab is isFocused is true
  useEffect(() => {
    isFocused && tabRef.current.focus();
  }, [isFocused]);

  // useEffect(() => {
  //   isFocused && tabRef.current.blur();
  // }, []);

  return (
    <button
      id={tabId}
      role="tab"
      onClick={() => {
        !isActive && clickHandler(tabId); // clickHandler() only works if the tab isn't active.
      }}
      // className={`${styles.tab} ${isActive ? styles.tabActive : ''}`}
      className={`tab ${isActive ? 'tabActive' : ''}`}
      aria-selected={isActive}
      aria-controls={tabpanelId} // Match the id of the panel to make aria happy
      onKeyDown={(e) => {
        keyDownHandler(e);
      }}
      tabIndex={isActive ? '0' : '-1'} // Only the active tab is tabbable, so that we can tab into and out of the tabpanel
      ref={tabRef}
    >
      {tabTitle}
    </button>
  );
};

Tab.propTypes = {
  tabTitle: PropTypes.string.isRequired,
  tabpanelId: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
  keyDownHandler: PropTypes.func.isRequired,
};

export default Tab;
